import React, { useState, useEffect } from 'react';
import Layout from '../../component/layout/Layout';
import './Announcement.css';

const Announcement = () => {
    const [activeSlide, setActiveSlide] = useState(0);

    // Optional: Auto-slide every 5 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            setActiveSlide((prev) => (prev === 0 ? 0 : 0)); // Only 1 slide for now
        }, 5000);

        return () => clearInterval(interval);
    }, []);

    const handleSlideChange = (index) => {
        setActiveSlide(index);
    };

    return (
        <Layout>
            {/* Hero Section */}
            <section id="hero">
                <div className="carousel slide carousel-fade">

                    {/* Indicators */}
                    <ol className="carousel-indicators" id="hero-carousel-indicators">
                        <li
                            className={activeSlide === 0 ? "active" : ""}
                            onClick={() => handleSlideChange(0)}
                        ></li>
                    </ol>

                    {/* Slides */}
                    <div className="carousel-inner" role="listbox">
                        <div
                            className={`carousel-item ${activeSlide === 0 ? "active" : ""}`}
                            style={{ backgroundImage: "url(/Carousel/Announce.jpg)" }}
                        >
                            <div className="carousel-container">
                                <div className="container">
                                    <div className="text" id='text'>
                                        <h2 className="animate__animated animate__fadeInDown">
                                            Announcement
                                        </h2>
                                        <h3
                                            className="animate__animated animate__fadeInTop"
                                            style={{ color: 'white' }}
                                        >
                                            Stay updated with our latest announcements and important updates.
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            {/* Force Majeure Letter Section */}
            <div className="letter-container">
                <div className="letter-card">

                    <div className="date-section">
                        <p className="date-text">08/03/2026</p>
                    </div>

                    <div className="recipients-section">
                        <p className="recipients-label">To</p>
                        <p className="recipients-name">
                            All our esteemed customers/partners/affiliates
                        </p>
                    </div>

                    <div className="subject-section">
                        <p className="subject-text">
                            Subject: Force Majeure Intimation
                        </p>
                    </div>

                    <div className="salutation-section">
                        <p className="salutation-text">Dear Sir/Madam,</p>
                    </div>

                    <div className="body-section">
                        <p>
                            We hereby inform you that certain events beyond our control,
                            including disruptions arising from the on-going situation in the
                            Gulf region, have affected the availability of essential inputs
                            required for our operations.
                        </p>

                        <p>
                            In view of the prevailing circumstances, performance of our
                            obligations under existing arrangements has impacted our ability
                            to supply.
                        </p>

                        <p>
                            The situation is being monitored, and updates will be shared as
                            appropriate.
                        </p>

                        <p>
                            This communication is issued without prejudice to our rights and
                            remedies under the applicable contracts and law, including
                            reliance on force majeure provisions, where applicable.
                        </p>

                        <p>We appreciate your understanding and thank you in advance.</p>
                    </div>

                    <div className="closing-section">
                        <p className="closing-text">Yours faithfully,</p>
                        <div className="signature-section">
                            <p className="company-name">For Rishabh Metals & Chemicals Private Limited</p>
                            <p className="authorized-signature">Authorized Signatory</p>

                        </div>
                    </div>

                </div>
            </div>
        </Layout>
    );
};

export default Announcement;